



























































































import { Component, Vue } from 'vue-property-decorator';

import { DateTime } from 'luxon';

import { Subscription } from '@/types/core-push';
import { CoreClient, curCoreClient } from '@/services/CoreClient';

import Loading from '@/components/Loading.vue';
import VueError from '@/components/VueError.vue';
import SubRow from '@/components/subscriptions/SubRow.vue';
import SubRowMobile from '@/components/subscriptions/SubRowMobile.vue';
import DeleteSub from '@/components/subscriptions/DeleteSub.vue';
import CreateSub from '@/components/subscriptions/CreateSub.vue';
import SearchBox from '@/components/SearchBox.vue';
import NumEntries from '@/components/NumEntries.vue';
import {SubUtil } from '@/util/SubUtil';
import {curPref} from "@/services/Preferences";
import { CsvUtil } from '@/util/CsvUtil';
import moment from 'moment';
import fileDownload from 'js-file-download';
import _ from 'lodash';

import tippy from 'tippy.js';

@Component({
  components: {
    Loading,
    VueError,
    SubRow,
    SubRowMobile,
    DeleteSub,
    CreateSub,
    SearchBox,
    NumEntries
  },
})
export default class SubList extends Vue {
  
  rawSubList:Subscription[] = [];
  subList:Subscription[] = [];
  error:string = '';
  status:'view-all'|'create'|'edit'|'delete' = 'view-all';
  selectedSub:Subscription = {} as Subscription;
  httpBusy:boolean = false;

  searchTerm = curPref.retrieve('v3-subs-search-term', '');

  // internal dependencies
  private coreClient:CoreClient = curCoreClient;
  private subUtil:SubUtil = new SubUtil();
  private csvUtil:CsvUtil = new CsvUtil();
  
  async mounted() {
    tippy('[data-tippy-content]');
    this.refreshData();
  }

  changeStatus(newStatus:'view-all'|'create'|'edit'|'delete', selectedSub?:Subscription) {
    
    this.status = newStatus;

    if(newStatus === 'view-all')
      this.refreshData();

    if(selectedSub)
      this.selectedSub = selectedSub;
  }

  async refreshData() {
    
    this.httpBusy = true;
    this.subList = [];
    this.error = '';

    const reply = await this.coreClient.getSubscriptions({skip:0, limit:1000});

    this.httpBusy = false;

    if(reply.httpCode === 403)
      return this.$router.push({name:'login'});

    if(reply.errorMsg)
      return this.error = `Unable to retrieve subscription list: ${reply.errorMsg}`;
    
    // we make a copy of the rawsub list
    this.rawSubList = (reply.subList as Subscription[]).concat();
    
    // we call filter
    this.subList = this.subUtil.filterSubs(this.rawSubList, this.searchTerm);
  }

  newSearchText(newSearchText:string) {

    curPref.store('v3-subs-search-term', newSearchText);

    this.searchTerm = newSearchText;
    
    // we call filter
    this.subList = this.subUtil.filterSubs(this.rawSubList, this.searchTerm);
  }

  exportList() {

    let csvExport = this.csvUtil.subListToCSV(this.subList.concat());

    let filename = `export-subscriptions-${moment().toISOString(true)}.csv`;

    fileDownload(csvExport, filename);
  }

  get showLoading():boolean {
    return this.httpBusy;
  }

  get showNoSubscriptions():boolean {
    return this.subList.length === 0 && !this.httpBusy && this.error === '' && this.searchTerm === '';
  }

  get showNoMatches():boolean {
    return !this.httpBusy && this.subList.length === 0 && this.searchTerm !== '' && this.error === '';
  }

  get showSubscriptions():boolean {
    return !this.httpBusy;
  }

  goToView(sub:Subscription) {
    return this.$router.push({name:'subscription', params: { subId: `${sub.subscriptionId}` }});
  }

  get numEntries():number {
    return this.subList.length;
  }

  get showNumEntries():boolean {
    return !this.httpBusy;
  }

}
